import { translate } from '@teamleader/i18n';
import cx from 'classnames';
import React, { useMemo } from 'react';

import { STATUS_MAP } from './StatusCell';
import styles from './styles.css';
import Box from '../../../../../../Components/UI/Box';
import Tooltip from '../../../../../../Components/UI/Tooltip';
import { Project, ProjectGroup, ProjectLineStatus, isProjectLine } from '../../../../../../Types/project';

const STATUSES = {
  [ProjectLineStatus.Todo]: 0,
  [ProjectLineStatus.InProgress]: 0,
  [ProjectLineStatus.Done]: 0,
  [ProjectLineStatus.OnHold]: 0,
};

interface Props {
  line: ProjectGroup | Project;
}

const StatusGroupCell = ({ line }: Props) => {
  const statuses = useMemo(() => {
    const statusMap = line.lines.reduce(
      (statuses, line) => {
        if (isProjectLine(line)) {
          statuses[line.status]++;
        } else {
          line.lines.forEach((groupLine) => statuses[groupLine.status]++);
        }
        return statuses;
      },
      { ...STATUSES },
    );

    return Object.entries(statusMap).filter((status) => status[1] > 0) as Array<[ProjectLineStatus, number]>;
  }, [line.lines]);

  if (line.lines.length === 0) {
    return <>-</>;
  }

  const tooltip = (
    <span className={styles['status-dots']}>
      {statuses.map(([status, amount]) => (
        <span key={status}>
          <span className={cx(styles['status-dot'], styles[`status--${status}`])} /> {amount}{' '}
          {translate(STATUS_MAP[status])}
        </span>
      ))}
    </span>
  );

  return (
    <Tooltip label={tooltip}>
      <Box className={styles['status-group-cell']}>
        {statuses.map(([status, amount]) => (
          <div key={status} className={styles[`status--${status}`]} style={{ flex: amount }} />
        ))}
      </Box>
    </Tooltip>
  );
};

export default StatusGroupCell;
